type BrandIcons = {
    [key: string]: string
  }
  
export const brandIcons: BrandIcons = {
    nike: require("../../assets/brands/nike.png"),
    newBalance: require("../../assets/brands/new-balance.png"),
    brooks: require("../../assets/brands/brooks.png"),
    dell: require("../../assets/brands/dell.png"),
    sony: require("../../assets/brands/sony.png"),
    fender: require("../../assets/brands/fender.png"),
    target: require("../../assets/brands/target.png"),
    volkswagen: require("../../assets/brands/volkswagen.png"),
    liveNation: require("../../assets/brands/live-nation.png"),
    columbusCrew: require("../../assets/brands/columbus-crew.png")
};